// ** Icons Import
import { ArrowRight, User, Shield, Zap } from 'react-feather'

export default [
  {
    id: 'users',
    title: 'Users',
    icon: <User size={20} />,
    children: [
      {
        id: 'list',
        title: 'All Users',
        icon: <ArrowRight size={12} />,
        navLink: '/apps/user/list',
        resource: 'User'
      }
    ]
  },
  {
    id: 'roles-permissions',
    title: 'Roles & Permissions',
    icon: <Shield size={20} />,
    children: [
      {
        id: 'roles',
        title: 'Roles',
        icon: <ArrowRight size={12} />,
        navLink: '/roles',
        resource: 'Role'
      },
      {
        id: 'permissions',
        title: 'Permissions',
        icon: <ArrowRight size={12} />,
        navLink: '/apps/permissions',
        resource: 'Role'
      }
    ]
  }
]
